var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ModalComponent',{attrs:{"name":"editar-categoria","title":"Editar categoría"},on:{"close":() => _vm.close()}},[_c('FormComponent',{attrs:{"categoria":_vm.categoriaTemporal,"loading":_vm.loading},on:{"terminado":_vm.editarCategoria}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }